import React from 'react';
import { InputTextarea } from 'primereact/inputtextarea';
import '../css/Form.css'
import useFormError from '../../hooks/useFormError';
import _ from 'lodash'

const ProTextArea = ({ id, labelText, value, rowCount = 1, style = { width: '100%', minHeight:"40px", minWidth: "350px"}, onChange, headerText, formik = {}, error, 
          required, rows, cols, maxLength = 500, showCounter }) => {
  const getFormErrorMessage = useFormError(formik);
  const placeholderText = required?<label htmlFor="inputtext">{labelText}</label>: <label htmlFor="inputtext">{labelText}<span style={{fontSize:11}}>  (optional)</span></label>
  return (
    <div>
    <div className={"p-field " + (+rowCount === 2 ? "p-col-6" : "p-col-12")}  >
      {
        headerText &&
        <div className="p-d-flex p-jc-start">
          <h6 className="form-header">{headerText}</h6>
        </div>
      }
      <span className="p-float-label" >
        <InputTextarea rows={rows} cols={cols} id={id} style={{ ...style }} value={value} onChange={onChange} autoResize maxLength={maxLength}  />     
        {placeholderText}
      </span> 
    </div>
    {showCounter &&   _.get(value, "length")? <div className="p-d-flex p-jc-end">
          <span style={{textAlign:"right"}}>{`${maxLength - value.length} characters remaining`}</span> 
          </div>
          :<div className="p-d-flex p-jc-end">
          <span style={{textAlign:"right"}}>{`${maxLength} characters remaining`}</span> 
          </div>}
    <div>
      {getFormErrorMessage && getFormErrorMessage(error)}
      </div>
    </div>

  )
}

export default ProTextArea;